export function setGFE(state, payload) {
  state.gfe = payload;
}
